/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class TenantMoveSubscriptionDialog extends NoboxEntityDialog<TenantRow, any> {
        protected getFormKey() { return TenantMoveSubscriptionForm.formKey; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getNameProperty() { return TenantRow.nameProperty; }
        protected getService() { return TenantService.baseUrl; }
        protected getDeletePermission() { return TenantRow.deletePermission; }
        protected getInsertPermission() { return TenantRow.insertPermission; }
        protected getUpdatePermission() { return TenantRow.updatePermission; }

        protected form = new TenantMoveSubscriptionForm(this.idPrefix);
        public moveUpdate = (item: TenantRow) => {

        }

        constructor(container?: JQuery) {
            super(container);
        }

        protected getToolbarButtons() {
            return [];
        }
        protected getDialogButtons() {
            var button = [];
            button.push({
                text: "OK",
                click: () => {
                    if (this.validateForm()) {
                        console.log(this.form.Server.value)
                        var entity = {} as TenantRow;
                        entity.Server = this.form.Server.value;
                        this.moveUpdate(entity);
                    }
                },
            });
            button.push({
                text: "CANCEL",
                click: () => { this.dialogClose() },
            });
            return button;
        }

    }
}